import prepareAjaxForm from "./lib/prepare-ajax-form";

const form = document.getElementById('resource-review-form')

if (form) {
    prepareAjaxForm(form)

    function updateStarClasses(value) {
        stars.forEach(star => {
            const currentItemValue = Number.parseInt(star.parentElement.querySelector('input').value)
            if (currentItemValue <= value) {
                star.classList.remove('fa-regular')
                star.classList.add('fa-solid')
            } else {
                star.classList.remove('fa-solid')
                star.classList.add('fa-regular')
            }
        })
    }

    function setPermanentStarClasses() {
        updateStarClasses(form.elements['rating'].value)
    }

    const stars = form.querySelectorAll('i')
    stars.forEach(star => {
        const radioBtn = star.parentNode.querySelector('input')
        star.addEventListener('mouseover', evt => {
            const value = evt.target.parentNode.querySelector('input[type="radio"]').value
            updateStarClasses(value)
        })
        star.addEventListener('mouseout', setPermanentStarClasses)
        radioBtn.addEventListener('change', setPermanentStarClasses)
    })
}
